enum ContractStatus {
  OPEN = 'open',
  CLOSED = 'closed',
}

export default ContractStatus;
